import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useRef
} from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";

import ColorPicker from "./ColorPicker"; //Probably wont use
import ColorPickerDialog from "./ColorPickerDialog"; //Probably wont use
import ColorPickerElement from "./ColorPickerElement";

import {
  Button,
  Divider,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TextField,
  Grid,
  Autocomplete,
  Typography,
  Chip
} from "@mui/material";

import { isValidIconName } from "../../../Kiosk/Components/ThankYou/StepIcon";
import IconSelector from "./IconSelector";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import UndoIcon from "@mui/icons-material/Undo";
import SaveIcon from "@mui/icons-material/Save";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import TranslationTextField from "./TranslationTextField";
import TranslationTextElement from "./TranslationTextElement";

import ContainerLoading from "../../../../components/Loading/ContainerLoading";

import ImageUploader from "./ImageUploader";

import { useTheme } from "@mui/material/styles";

import HttpContext from "../../../../contexts/HTTP/HttpContext";

let env = require("./../../../../env");

// Show sticky element based on scroll position relative to trigger
const useScrollTrigger = (options = {}) => {
  const [showSticky, setShowSticky] = useState(false);
  const [triggerPosition, setTriggerPosition] = useState(0);
  const targetRef = useRef(null);

  useEffect(() => {
    const updateTriggerPosition = () => {
      if (targetRef.current) {
        const rect = targetRef.current.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        setTriggerPosition(rect.top + scrollTop);
      }
    };

    const handleScroll = () => {
      const currentScrollY =
        window.pageYOffset || document.documentElement.scrollTop;

      // Show sticky element when we've scrolled past the trigger
      setShowSticky(currentScrollY > triggerPosition);
    };

    // Update trigger position on mount and resize
    updateTriggerPosition();
    window.addEventListener("resize", updateTriggerPosition);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", updateTriggerPosition);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [triggerPosition]);

  // Update trigger position when component mounts or updates
  useEffect(() => {
    const updateTriggerPosition = () => {
      if (targetRef.current) {
        const rect = targetRef.current.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        setTriggerPosition(rect.top + scrollTop);
      }
    };

    updateTriggerPosition();
  }, []);

  return { targetRef, showSticky };
};

const MyAccordionHeader = React.memo(
  ({
    title,
    grouping,
    bgcolor = "f5f5f5",
    expandedSectionFlag,
    expandedSections,
    handleAccordionChange
  }) => {
    // Remove local state - use the parent's state directly
    const isExpanded = expandedSections.has(expandedSectionFlag);

    return (
      <div
        className="ItemHeader" // Use className instead of class
        style={{
          backgroundColor: bgcolor,
          border: "1px solid #e0e0e0",
          padding: "0 16px",
          cursor: "pointer" // Add cursor pointer for better UX
        }}
        onClick={() => {
          console.log(
            "[MyAccordionHeader] toggling",
            expandedSectionFlag,
            "currently expanded:",
            isExpanded
          );
          // Call the handler with the section ID and current expanded state
          handleAccordionChange(expandedSectionFlag)(null, !isExpanded);
        }}
      >
        <div
          style={{
            margin: "12px 0",
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap", // Fix typo: "nowarp" -> "nowrap"
            justifyContent: "space-between",
            width: "100%"
          }}
        >
          <Grid item xs={6} style={{ alignContent: "center" }}>
            <Typography>
              {title}
              {grouping && (
                <>
                  {" "}
                  {grouping.split(",").map(groupItem => (
                    <Chip
                      label={groupItem.trim()}
                      size="small"
                      sx={{
                        backgroundColor: "black",
                        color: "white" // text color
                      }}
                    />
                  ))}
                </>
              )}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              alignContent: "right"
            }}
          >
            <div>{isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</div>
          </Grid>
          {/* <Typography>{title}</Typography>
          <div>{isExpanded ? "−" : "+"}</div>  */}
        </div>
      </div>
    );
  }
);

const MyAccordionBody = React.memo(({ children, show }) => {
  return (
    <div
      class="ItemBody"
      style={{
        backgroundColor: "#ffffff",
        border: "1px solid #e0e0e0",
        padding: "0 16px",
        maxHeight: show ? "100vh" : "0vh", // Use a large enough max-height
        overflow: "hidden",
        transition: "max-height 0.3s ease-in-out"
      }}
    >
      <div
        style={{
          margin: "12px 0"
          //display: show ? "block" : "none"
        }}
      >
        {/* BODY CONTENT */}
        <Grid container spacing={2}>
          {children}
        </Grid>
      </div>
    </div>
  );
});

export default function KioskThemePanel({
  initialtheme,
  // open,
  hasChange,
  setHasChange,
  loading,
  // handleClose,
  handleSaveEditChanges
}) {
  // Use the scroll trigger hook
  const { targetRef, showSticky } = useScrollTrigger();

  // Stabilize the setHasChange function using useRef
  const setHasChangeRef = useRef();
  setHasChangeRef.current = setHasChange;

  const stableSetHasChange = useCallback(value => {
    setHasChangeRef.current(value);
  }, []);

  // Stabilize other callback props too
  const handleSaveRef = useRef();
  handleSaveRef.current = handleSaveEditChanges;

  // const stableHandleSave = useCallback(async payload => {
  //   await handleSaveRef.current(payload);
  // }, []);

  // Add this debug block RIGHT AT THE TOP
  console.log("[KioskThemePanel] COMPONENT RENDER");

  const theme = useTheme();
  const { get, post } = useContext(HttpContext);

  // DEBUG: Add this to track what's causing re-renders
  const renderCount = useRef(0);
  renderCount.current += 1;

  const prevProps = useRef({});
  useEffect(() => {
    const currentProps = {
      initialtheme,
      // open,
      hasChange,
      loading
    };
    Object.keys(currentProps).forEach(key => {
      if (prevProps.current[key] !== currentProps[key]) {
        console.log(`[KioskThemePanel] PROP CHANGED: ${key}`, {
          prev: prevProps.current[key],
          current: currentProps[key]
        });
      }
    });
    prevProps.current = currentProps;
  });

  // ... your existing state declarations ...
  const [currentTheme, setCurrentTheme] = useState({});

  // Track when theme changes (AFTER currentTheme is declared)
  const prevTheme = useRef();
  useEffect(() => {
    if (prevTheme.current !== currentTheme) {
      console.log("[KioskThemePanel] currentTheme changed", {
        prev: prevTheme.current,
        current: currentTheme
      });
      prevTheme.current = currentTheme;
    }
  }, [currentTheme]);

  console.log(`[KioskThemePanel] Render #${renderCount.current}`);

  // Rest of your component...
  const [currentLanguageTab, setCurrentLanguageTab] = useState("En");
  const [currentBilingualSetting, setCurrentBilingualSetting] = useState("");

  const [expandedSections, setExpandedSections] = useState(
    new Set([
      "color-override",
      "color-other",
      "color-stepper",
      "color-main-screen",
      "color-qr-code",
      "color-quick-donation",
      "color-charity-element",
      "color-telephone",
      "color-inner",
      "color-header-footer",
      "main-screen",
      "quickstart-qr",
      "donations",
      "customer-telephone",
      "wizard",
      "footer",
      "bagsonly",
      "select-bags",
      "select-labels",
      "approval-screen",
      "ready-to-print",
      "thank-you"
    ])
  );

  // const [currentTheme, setCurrentTheme] = useState({});

  //Reloading theme
  useEffect(() => {
    if (initialtheme) {
      setCurrentTheme({ ...initialtheme });
      setCurrentBilingualSetting(initialtheme.bilingual);
      if (!initialtheme.bilingual) {
        setCurrentLanguageTab("En");
      } else {
        setCurrentLanguageTab("Fr");
      }
    }
  }, [initialtheme]);

  const saveChanges = async () => {
    const payload = currentTheme;
    await handleSaveEditChanges(payload);
  };

  const revertChanges = async () => {
    if (initialtheme) {
      setCurrentTheme({ ...initialtheme });
      setCurrentBilingualSetting(initialtheme.bilingual);
      if (!initialtheme.bilingual) {
        setCurrentLanguageTab("En");
      }
      setHasChangeRef.current(false);
    }
  };

  const handleChangeLanguageTab = (event, newValue) => {
    setCurrentLanguageTab(newValue);
  };

  const handleUpdateChanges = useCallback(async newchanges => {
    setCurrentTheme(prevTheme => {
      const updatedTheme = { ...prevTheme, ...newchanges };
      console.log(
        "[handleUpdateChanges] DEBUG updatedTheme, newchanges",
        updatedTheme,
        newchanges
      );
      return updatedTheme;
    });
    setHasChangeRef.current(true); // Use ref directly instead of stableSetHasChange
  }, []); // Empty dependencies - now truly stable

  const handleTranslationUpdate = useCallback(
    (translationValue, language, newValue) => {
      setCurrentTheme(prevTheme => ({
        ...prevTheme,
        translations: {
          ...prevTheme.translations,
          [translationValue]: {
            ...prevTheme.translations?.[translationValue],
            [language]: newValue
          }
        }
      }));
      setHasChangeRef.current(true); // Use the ref directly instead of stableSetHasChange
    },
    [] // Now this is truly stable
  );

  const handleAccordionChange = sectionId => (event, isExpanded) => {
    console.log("[handleAccordionChange] event, isExpanded", event, isExpanded);
    setExpandedSections(prev => {
      const newSet = new Set(prev);
      if (isExpanded) {
        console.log("[handleAccordionChange] add sectionId", sectionId);
        newSet.add(sectionId);
      } else {
        newSet.delete(sectionId);
        console.log("[handleAccordionChange] delete sectionId", sectionId);
      }
      return newSet;
    });
  };

  const hashFunc = str => {
    const combined = str;
    let hash = 1234;

    for (let i = 0; i < combined.length; i++) {
      hash = (hash << 5) + hash + combined.charCodeAt(i);
      hash = hash & hash; // Convert to 32-bit integer
    }

    return Math.abs(hash);
  };

  const hashHexFromTime = () => {
    const hash = hashFunc(Date.now().toString());
    return hash.toString(16);
  };

  return (
    <>
      {/* Sticky Header */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginTop: theme.spacing(2),
          position: "sticky",
          top: "0px",
          height: "50px",
          zIndex: 20,
          backgroundColor: "rgb(245, 245, 245)"
        }}
      >
        <div>
          {showSticky && (
            <div style={{ top: "6px", backgroundColor: "rgb(245, 245, 245)" }}>
              <Tabs
                value={currentLanguageTab}
                onChange={handleChangeLanguageTab}
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="tabs for changing language"
                sx={{ marginTop: "0px" }}
                centered
              >
                {currentBilingualSetting && <Tab value="Fr" label="French" />}
                <Tab value="En" label="English" />
              </Tabs>
            </div>
          )}
        </div>
        <div
          style={{
            position: "absolute",
            right: 0,
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing(1),
            top: "0px",
            margin: "6px",
            backgroundColor: "rgb(245, 245, 245)"
          }}
        >
          {hasChange ? (
            <div
              style={{
                marginTop: "6px",
                fontStyle: "italic",
                color: "darkorange"
              }}
            >
              Changes pending
            </div>
          ) : (
            <></>
          )}
          <Button
            variant="outline"
            onClick={() => revertChanges()}
            disabled={loading}
          >
            <UndoIcon style={{ marginRight: theme.spacing(1) }} />
            Revert
          </Button>
          <Button
            variant="contained"
            onClick={() => saveChanges()}
            disabled={loading}
          >
            <SaveIcon style={{ marginRight: theme.spacing(1) }} />
            Save
          </Button>
        </div>
      </div>
      {/* / Sticky Header */}

      <Divider
        style={{ marginBottom: theme.spacing(2), marginTop: theme.spacing(2) }}
      />
      <ContainerLoading show={loading} />
      <TableContainer>
        <Table
          style={{
            marginTop: theme.spacing(2),
            display: loading ? "none" : null
          }}
        >
          <TableHead></TableHead>

          <center>
            {/* <Grid container width="30vw" spacing={2}> */}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    pb: 1,
                    mb: 1
                  }}
                >
                  <Typography
                    variant="h6"
                    color="primary"
                    sx={{ fontWeight: 600 }}
                  >
                    View Settings
                  </Typography>
                </Box>
              </Grid>

              {currentTheme.webDisplayMode && (
                <>
                  <Grid item xs={6} style={{ alignContent: "center" }}>
                    Web Display Mode
                  </Grid>
                  <Grid item xs={6} style={{ alignContent: "center" }}>
                    <FormControl sx={{ m: 1, minWidth: 230 }}>
                      <Select
                        labelId="batch-update-open-select-label"
                        id="batch-update-open-select"
                        value={currentTheme.webDisplayMode}
                        onChange={async event => {
                          handleUpdateChanges({
                            webDisplayMode: event.target.value
                          });
                        }}
                      >
                        <MenuItem value={"auto"}>Auto</MenuItem>
                        <MenuItem value={"vertical"}>Vertical Only</MenuItem>
                        <MenuItem value={"horizontal"}>
                          Horizontal Only
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </>
              )}

              {currentTheme.deviceDisplayMode && (
                <>
                  <Grid item xs={6} style={{ alignContent: "center" }}>
                    Device Display Mode
                  </Grid>
                  <Grid item xs={6} style={{ alignContent: "center" }}>
                    <FormControl sx={{ m: 1, minWidth: 230 }}>
                      <Select
                        labelId="batch-update-open-select-label"
                        id="batch-update-open-select"
                        value={currentTheme.deviceDisplayMode}
                        onChange={async event => {
                          handleUpdateChanges({
                            deviceDisplayMode: event.target.value
                          });
                        }}
                      >
                        <MenuItem value={"auto"}>Auto</MenuItem>
                        <MenuItem value={"vertical"}>Vertical Only</MenuItem>
                        <MenuItem value={"horizontal"}>
                          Horizontal Only
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </>
              )}

              {/* MOVED TO SERVERSETTINGS */}
              {/* <Grid item xs={12}>
                <Box
                  sx={{
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    pb: 1,
                    mb: 1,
                    mt: 2
                  }}
                >
                  <Typography
                    variant="h6"
                    color="primary"
                    sx={{ fontWeight: 600 }}
                  >
                    Kiosk Settings
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                App Name
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <TextField
                  id="txtAppName"
                  value={currentTheme.appName}
                  onChange={event => {
                    handleUpdateChanges({ appName: event.target.value });
                    //DEBUG
                    document.title = event.target.value;
                  }}
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white"
                    }
                  }}
                />
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Bi-Lingual
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <Switch
                  checked={currentTheme.bilingual}
                  onChange={event => {
                    handleUpdateChanges({ bilingual: event.target.checked });

                    if (event.target.checked == false) {
                      setCurrentLanguageTab("En");
                      setCurrentBilingualSetting(false);
                    } else {
                      setCurrentBilingualSetting(true);
                    }
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Quick Start
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <Switch
                  checked={currentTheme.quickStart}
                  onChange={event => {
                    //setQuickStart(event.target.checked);
                    handleUpdateChanges({ quickStart: event.target.checked });
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Enable Charities
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <Switch
                  checked={currentTheme.enableCharities}
                  onChange={event => {
                    handleUpdateChanges({
                      enableCharities: event.target.checked
                    });
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Show Partner Logo
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <Switch
                  checked={currentTheme.showPartnerLogo}
                  onChange={event => {
                    handleUpdateChanges({
                      showPartnerLogo: event.target.checked
                    });
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Days to Count
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <TextField
                  id="txtDaysToCount"
                  value={currentTheme.daysToCount}
                  onChange={event => {
                    //setDaysToCount(event.target.value);
                    handleUpdateChanges({ daysToCount: event.target.value });
                  }}
                  variant="outlined"
                  fullWidth
                  type="number"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white"
                    }
                  }}
                />
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Phone Format
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <TextField
                  id="txtPhoneFormat"
                  value={currentTheme.phoneFormat}
                  onChange={event => {
                    handleUpdateChanges({ phoneFormat: event.target.value });
                  }}
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white"
                    }
                  }}
                />
              </Grid> */}

              {/* ------------------------------------------------ */}

              <Grid item xs={12}>
                <Box
                  sx={{
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    pb: 1,
                    mb: 1,
                    mt: 2
                  }}
                >
                  <Typography
                    variant="h6"
                    color="primary"
                    sx={{ fontWeight: 600 }}
                  >
                    Images & Logos
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Header Logo
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                >
                  1693 x 227
                </div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <ImageUploader
                  previewImgPath={
                    env.REACT_APP_API_ENDPOINT +
                    "/kiosk/getImage/HeaderLogo1" +
                    "?t=" +
                    currentTheme.lastUpdatedImgETag
                  }
                  // expectedWidth={1693}
                  // expectedHeight={227}
                  post={post}
                  ImageType={"HeaderLogo1"}
                  setPathFunc={filename => {
                    handleUpdateChanges({
                      headerLogoPath: filename
                    });
                  }}
                />
              </Grid>

              {currentBilingualSetting && (
                <>
                  <Grid item xs={6} style={{ alignContent: "center" }}>
                    French Splash Image
                    <br />
                    <div
                      style={{
                        color: "grey",
                        fontStyle: "italic"
                      }}
                    >
                      525 x 798
                    </div>
                  </Grid>
                  <Grid item xs={6} style={{ alignContent: "center" }}>
                    <ImageUploader
                      previewImgPath={
                        env.REACT_APP_API_ENDPOINT +
                        "/kiosk/getImage/HSplashFr" +
                        "?t=" +
                        currentTheme.lastUpdatedImgETag
                      }
                      // expectedWidth={1693}
                      // expectedHeight={227}
                      post={post}
                      ImageType={"HSplashFr"}
                      setPathFunc={filename => {
                        handleUpdateChanges({
                          hSplashFrPath: filename
                        });
                      }}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={6} style={{ alignContent: "center" }}>
                English Splash Image
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                >
                  525 x 798
                </div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <ImageUploader
                  previewImgPath={
                    env.REACT_APP_API_ENDPOINT +
                    "/kiosk/getImage/HSplashEn" +
                    "?t=" +
                    currentTheme.lastUpdatedImgETag
                  }
                  // expectedWidth={1693}
                  // expectedHeight={227}
                  post={post}
                  ImageType={"HSplashEn"}
                  setPathFunc={filename => {
                    handleUpdateChanges({
                      hSplashEnPath: filename
                    });
                  }}
                />
              </Grid>

              {/* Not used below */}
              {/* <Grid item xs={6} style={{ alignContent: "center" }}>
                Header Logo2
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <ImageUploader
                  previewImgPath={
                    env.REACT_APP_API_ENDPOINT + "/kiosk/getImage/HeaderLogo2"
                  }
                  post={post}
                  ImageType={"HeaderLogo2"}
                  setPathFunc={filename => {
                    handleUpdateChanges({ headerLogo2Path: filename });
                  }}
                />
              </Grid> */}
              <Grid item xs={6} style={{ alignContent: "center" }}>
                QR Logo
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                >
                  200 x 200
                </div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <ImageUploader
                  previewImgPath={
                    env.REACT_APP_API_ENDPOINT +
                    "/kiosk/getImage/QRLogo" +
                    "?t=" +
                    currentTheme.lastUpdatedImgETag
                  }
                  // expectedWidth={200}
                  // expectedHeight={200}
                  post={post}
                  ImageType={"QRLogo"}
                  setPathFunc={filename => {
                    handleUpdateChanges({
                      qrLogoPath: filename
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Partnering with Logo
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                >
                  500 x 500
                </div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <ImageUploader
                  previewImgPath={
                    env.REACT_APP_API_ENDPOINT +
                    "/kiosk/getImage/PartneringLogo" +
                    "?t=" +
                    currentTheme.lastUpdatedImgETag
                  }
                  post={post}
                  ImageType={"PartneringLogo"}
                  setPathFunc={filename => {
                    handleUpdateChanges({
                      partneringLogoPath: filename
                    });
                  }}
                />
              </Grid>

              {/* ICONS */}
              {/* <Grid item xs={6} style={{ alignContent: "center" }}>
                Step 1 Icon
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                ></div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    width: "100%",
                    alignItems: "flex-start"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "407px",
                      flexGrow: 1
                    }}
                  >
                    <StepIcon
                      DefaultIcon={"CheckBoxOutlined"}
                      cssSizeString={"5em"}
                      iconName={currentTheme.thankyouStep1Icon}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      minWidth: 300,
                      flexGrow: 2
                    }}
                  >
                    <TextField
                      id={"txtStep1Icon"}
                      value={currentTheme.thankyouStep1Icon}
                      onChange={event => {
                        handleUpdateChanges({
                          thankyouStep1Icon: event.target.value
                        });
                      }}
                      variant="outlined"
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white"
                        }
                      }}
                    />
                    https://mui.com/material-ui/material-icons/ Example:
                    CheckBoxOutlined
                  </div>
                </div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                Step 2 Icon
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                ></div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    width: "100%",
                    alignItems: "flex-start"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "407px",
                      flexGrow: 1
                    }}
                  >
                    <StepIcon
                      DefaultIcon={"ArrowDropDownCircle"}
                      cssSizeString={"5em"}
                      iconName={currentTheme.thankyouStep2Icon}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      minWidth: 300,
                      flexGrow: 2
                    }}
                  >
                    <TextField
                      id={"txtStep2Icon"}
                      value={currentTheme.thankyouStep2Icon}
                      onChange={event => {
                        handleUpdateChanges({
                          thankyouStep2Icon: event.target.value
                        });
                      }}
                      variant="outlined"
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white"
                        }
                      }}
                    />
                    https://mui.com/material-ui/material-icons/ Example:
                    ArrowDropDownCircle
                  </div>
                </div>
              </Grid> */}
              <Grid item xs={6} style={{ alignContent: "center" }}>
                Step 1 Icon
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                ></div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <IconSelector
                  DefaultIcon={"CheckBoxOutlined"}
                  iconName={currentTheme.thankyouStep1Icon}
                  onChange={event => {
                    console.log(
                      "[DEBUG] IconSelector onChange",
                      event.target.value
                    );
                    handleUpdateChanges({
                      thankyouStep1Icon: event.target.value
                    });
                  }}
                />
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                Step 2 Icon
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                ></div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <IconSelector
                  DefaultIcon={"ArrowDropDownCircle"}
                  iconName={currentTheme.thankyouStep2Icon}
                  onChange={event => {
                    console.log(
                      "[DEBUG] IconSelector onChange",
                      event.target.value
                    );
                    handleUpdateChanges({
                      thankyouStep2Icon: event.target.value
                    });
                  }}
                />
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                Step 3 Icon
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                ></div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <IconSelector
                  DefaultIcon={"SentimentSatisfiedAlt"}
                  iconName={currentTheme.thankyouStep3Icon}
                  onChange={event => {
                    console.log(
                      "[DEBUG] IconSelector onChange",
                      event.target.value
                    );
                    handleUpdateChanges({
                      thankyouStep3Icon: event.target.value
                    });
                  }}
                />
              </Grid>

              {/* <Grid item xs={6} style={{ alignContent: "center" }}>
                Step 1
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                >
                  500 x 500
                </div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <ImageUploader
                  previewImgPath={
                    env.REACT_APP_API_ENDPOINT +
                    "/kiosk/getImage/ThankyouStep1Icon" +
                    "?t=" +
                    currentTheme.lastUpdatedImgETag
                  }
                  post={post}
                  ImageType={"ThankyouStep1Icon"}
                  setPathFunc={filename => {
                    handleUpdateChanges({
                      thankyouStep1IconPath: filename
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Step 2
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                >
                  500 x 500
                </div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <ImageUploader
                  previewImgPath={
                    env.REACT_APP_API_ENDPOINT +
                    "/kiosk/getImage/ThankyouStep2Icon" +
                    "?t=" +
                    currentTheme.lastUpdatedImgETag
                  }
                  post={post}
                  ImageType={"ThankyouStep2Icon"}
                  setPathFunc={filename => {
                    handleUpdateChanges({
                      thankyouStep2IconPath: filename
                    });
                  }}
                />
              </Grid>

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Step 3
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                >
                  500 x 500
                </div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <ImageUploader
                  previewImgPath={
                    env.REACT_APP_API_ENDPOINT +
                    "/kiosk/getImage/ThankyouStep3Icon" +
                    "?t=" +
                    currentTheme.lastUpdatedImgETag
                  }
                  post={post}
                  ImageType={"ThankyouStep3Icon"}
                  setPathFunc={filename => {
                    handleUpdateChanges({
                      thankyouStep3IconPath: filename
                    });
                  }}
                />
              </Grid> */}

              <Grid item xs={6} style={{ alignContent: "center" }}>
                Charity Fallback
                <br />
                <div
                  style={{
                    color: "grey",
                    fontStyle: "italic"
                  }}
                >
                  500 x 250
                </div>
              </Grid>
              <Grid item xs={6} style={{ alignContent: "center" }}>
                <ImageUploader
                  previewImgPath={
                    env.REACT_APP_API_ENDPOINT +
                    "/kiosk/getImage/CharityFallback" +
                    "?t=" +
                    currentTheme.lastUpdatedImgETag
                  }
                  post={post}
                  ImageType={"CharityFallback"}
                  setPathFunc={filename => {
                    handleUpdateChanges({
                      charityFallbackPath: filename
                    });
                  }}
                />
              </Grid>
              {/* ------------------------------------------------ */}

              <Grid item xs={12}>
                <Box
                  sx={{
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    pb: 1,
                    mb: 1
                  }}
                >
                  <Typography
                    variant="h6"
                    color="primary"
                    sx={{ fontWeight: 600 }}
                  >
                    Colors
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Base Color Override"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"color-override"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("color-override")}>
                  <ColorPickerElement
                    property={"primaryColor"}
                    initialColor={currentTheme.primaryColor}
                    label="Primary Color"
                    updateChanges={handleUpdateChanges}
                    linkedProperties={[
                      "mainscreenTextColor",
                      "mainscreenBGColor",
                      "mainscreenButtonsTextColor",
                      "quickStartQRTextColor",
                      "quickStartQRCodeColor",
                      "headerFooterBGColor",
                      "adminHeaderColor"
                    ]}
                  />

                  <ColorPickerElement
                    property={"secondaryColor"}
                    initialColor={currentTheme.secondaryColor}
                    label="Secondary Color"
                    updateChanges={handleUpdateChanges}
                    linkedProperties={[
                      "mainscreenTextColor",
                      "mainscreenButtonsBGColor",
                      "quickStartQRTextColor",
                      "telephoneConfirmTextColor",
                      "innerBGColor",
                      "buttonsTextColor",
                      "headerFooterTextColor",
                      "headerFooterButtonTextColor",
                      "configCloseTextColor",
                      "stepperButtonTextColor",
                      "quickStartQuickDonateTextColor",
                      "charityElementBgColor"
                    ]}
                  />

                  <ColorPickerElement
                    property={"trinaryColor"}
                    initialColor={currentTheme.trinaryColor}
                    label="Trinary Color"
                    updateChanges={handleUpdateChanges}
                    linkedProperties={[
                      "quickStartQRDivColor",
                      "telephoneConfirmDivColor",
                      "innerTextColor",
                      "buttonsBGColor",
                      "headerFooterButtonBGColor",
                      "configCloseBGColor",
                      "stepperStepBGColor",
                      "stepperButtonBGColor",
                      "quickStartQuickDonateIconColor",
                      "quickStartQuickDonateDivColor",
                      "charityModalTextColor",
                      "charityFindButtonColor"
                    ]}
                  />
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Others"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"color-other"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("color-other")}>
                  <ColorPickerElement
                    property={"adminHeaderColor"}
                    initialColor={currentTheme.adminHeaderColor}
                    label="Admin Header Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"languageButtonTextColor"}
                    initialColor={currentTheme.languageButtonTextColor}
                    label="Language Button Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"languageButtonBGColor"}
                    initialColor={currentTheme.languageButtonBGColor}
                    label="Language Button BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"yesNoTextColor"}
                    initialColor={currentTheme.yesNoTextColor}
                    label="Yes/No Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"yesBGColor"}
                    initialColor={currentTheme.yesBGColor}
                    label="Yes BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"noBGColor"}
                    initialColor={currentTheme.noBGColor}
                    label="No BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"configCloseBGColor"}
                    initialColor={currentTheme.configCloseBGColor}
                    label="Setting Close BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"configCloseTextColor"}
                    initialColor={currentTheme.configCloseTextColor}
                    label="Setting Close Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Stepper"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"color-stepper"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("color-stepper")}>
                  <ColorPickerElement
                    property={"stepperStepBGColor"}
                    initialColor={currentTheme.stepperStepBGColor}
                    label="Step BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                  {/* <ColorPickerElement
                    property={"stepperStepTextColor"}
                    initialColor={currentTheme.stepperStepTextColor}
                    label="Step Text Color"
                    updateChanges={handleUpdateChanges}
                  /> */}
                  <ColorPickerElement
                    property={"stepperButtonBGColor"}
                    initialColor={currentTheme.stepperButtonBGColor}
                    label="Button BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"stepperButtonTextColor"}
                    initialColor={currentTheme.stepperButtonTextColor}
                    label="Button Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Main Screen"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"color-main-screen"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody
                  show={expandedSections.has("color-main-screen")}
                >
                  <ColorPickerElement
                    property={"mainscreenBGColor"}
                    initialColor={currentTheme.mainscreenBGColor}
                    label="Background Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"mainscreenTextColor"}
                    initialColor={currentTheme.mainscreenTextColor}
                    label="Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"mainscreenButtonsTextColor"}
                    initialColor={currentTheme.mainscreenButtonsTextColor}
                    label="Button Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"mainscreenButtonsBGColor"}
                    initialColor={currentTheme.mainscreenButtonsBGColor}
                    label="Button BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"splashPageBGColor"}
                    initialColor={currentTheme.splashPageBGColor}
                    label="Splash Page BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Main Screen Qr Code"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"color-qr-code"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("color-qr-code")}>
                  <ColorPickerElement
                    property={"quickStartQRCodeColor"}
                    initialColor={currentTheme.quickStartQRCodeColor}
                    label="Quick Start QR Code Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"quickStartQRBGColor"}
                    initialColor={currentTheme.quickStartQRBGColor}
                    label="Quick Start QR Background Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"quickStartQRTextColor"}
                    initialColor={currentTheme.quickStartQRTextColor}
                    label="Quick Start QR Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"quickStartQRDivColor"}
                    initialColor={currentTheme.quickStartQRDivColor}
                    label="Quick Start QR Background Color"
                    updateChanges={handleUpdateChanges}
                  />
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Main Screen Quick Donation"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"color-quick-donation"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody
                  show={expandedSections.has("color-quick-donation")}
                >
                  <ColorPickerElement
                    property={"quickStartQuickDonateIconColor"}
                    initialColor={currentTheme.quickStartQuickDonateIconColor}
                    label="Quick Donation Icon Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"quickStartQuickDonateBGColor"}
                    initialColor={currentTheme.quickStartQuickDonateBGColor}
                    label="Quick Donation Icon Background Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"quickStartQuickDonateTextColor"}
                    initialColor={currentTheme.quickStartQuickDonateTextColor}
                    label="Quick Donation Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"quickStartQuickDonateDivColor"}
                    initialColor={currentTheme.quickStartQuickDonateDivColor}
                    label="Quick Donation Background Color"
                    updateChanges={handleUpdateChanges}
                  />
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Donations"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"color-charity-element"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody
                  show={expandedSections.has("color-charity-element")}
                >
                  <ColorPickerElement
                    property={"charityModalTextColor"}
                    initialColor={currentTheme.charityModalTextColor}
                    label="Donation Modal Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"charityElementBgColor"}
                    initialColor={currentTheme.charityElementBgColor}
                    label="Charity Element BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"charityElementButtonColor"}
                    initialColor={currentTheme.charityElementButtonColor}
                    label="Charity Element Button Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"charityElementButtonBGColor"}
                    initialColor={currentTheme.charityElementButtonBGColor}
                    label="Charity Element Button BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"charityFindButtonColor"}
                    initialColor={currentTheme.charityFindButtonColor}
                    label="Charity Find Button Color"
                    updateChanges={handleUpdateChanges}
                  />
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Telephone Screen"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"color-telephone"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("color-telephone")}>
                  <ColorPickerElement
                    property={"telephoneConfirmTextColor"}
                    initialColor={currentTheme.telephoneConfirmTextColor}
                    label="Confirm Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"telephoneConfirmDivColor"}
                    initialColor={currentTheme.telephoneConfirmDivColor}
                    label="Confim BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Inner"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"color-inner"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("color-inner")}>
                  <ColorPickerElement
                    property={"innerBGColor"}
                    initialColor={currentTheme.innerBGColor}
                    label="Background Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"innerTextColor"}
                    initialColor={currentTheme.innerTextColor}
                    label="Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  {/* <ColorPickerElement
                    property={"innerAltTextColor"}
                    initialColor={currentTheme.innerAltTextColor}
                    label="Alt Text Color (Horizontal View)"
                    updateChanges={handleUpdateChanges}
                  /> */}
                  <ColorPickerElement
                    property={"buttonsTextColor"}
                    initialColor={currentTheme.buttonsTextColor}
                    label="Inner Buttons Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"buttonsBGColor"}
                    initialColor={currentTheme.buttonsBGColor}
                    label="Inner Buttons BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Header/Footer"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"color-header-footer"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody
                  show={expandedSections.has("color-header-footer")}
                >
                  <ColorPickerElement
                    property={"headerFooterBGColor"}
                    initialColor={currentTheme.headerFooterBGColor}
                    label="Background Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"headerFooterTextColor"}
                    initialColor={currentTheme.headerFooterTextColor}
                    label="Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"headerFooterButtonTextColor"}
                    initialColor={currentTheme.headerFooterButtonTextColor}
                    label="Buttons Text Color"
                    updateChanges={handleUpdateChanges}
                  />
                  <ColorPickerElement
                    property={"headerFooterButtonBGColor"}
                    initialColor={currentTheme.headerFooterButtonBGColor}
                    label="Buttons BG Color"
                    updateChanges={handleUpdateChanges}
                  />
                </MyAccordionBody>
              </Grid>

              {/* ////////////////////////////////////////// */}

              <Grid item xs={12}>
                <Box
                  sx={{
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    pb: 1,
                    mb: 1,
                    mt: 2,
                    position: "sticky",
                    top: "80px", // Adjust this value based on your save/revert button height
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)" // Optional: adds a subtle shadow
                  }}
                >
                  <Typography
                    variant="h6"
                    color="primary"
                    sx={{ fontWeight: 600 }}
                  >
                    Translations
                  </Typography>
                  <Tabs
                    value={currentLanguageTab}
                    onChange={handleChangeLanguageTab}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="tabs for changing language"
                    centered
                  >
                    {currentBilingualSetting && (
                      <Tab value="Fr" label="French" />
                    )}
                    <Tab value="En" label="English" />
                  </Tabs>
                </Box>
              </Grid>
              {/* This should be positioned right before your translation sections */}
              <Grid item xs={12} id="translationHeaderScrollTrigger">
                <div ref={targetRef} style={{ height: "1px" }} />
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Main Screen"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"main-screen"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("main-screen")}>
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Main Text"
                      translationValue="languageSelectMainText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Continue Button"
                      translationValue="languageSelectContinueButton"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Quick Start QR"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"quickstart-qr"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("quickstart-qr")}>
                  {currentTheme && (
                    <TranslationTextElement
                      label="Title"
                      grouping="Horizonal"
                      translationValue="quickStartQRTitle"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="QR Header"
                      translationValue="quickStartQRHeader"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="QR Body"
                      translationValue="quickStartQRBody"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Partner Title"
                      translationValue="partnerTitle"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Donation Button Header"
                      translationValue="donationHeader"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Donation Button Body"
                      translationValue="donationBody"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Donations"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"donations"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("donations")}>
                  {currentTheme && (
                    <TranslationTextElement
                      label="Choose A Charity"
                      translationValue="charityChooseACharity"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Donate Now"
                      translationValue="charityDonateNow"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Select Charity Instruction"
                      translationValue="charitySelectCharityInstruction"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Find By Id"
                      translationValue="charityFindById"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Search Charity"
                      translationValue="charitySearchCharity"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Search Charity Instruction"
                      translationValue="charitySearchCharityInstruction"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Confirm Select"
                      translationValue="charityConfirmSelect"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Confirm Search"
                      translationValue="charityConfirmSearch"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Telephone"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"customer-telephone"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody
                  show={expandedSections.has("customer-telephone")}
                >
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="WelcomeText"
                      translationValue="telephoneWelcomeText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Sign In Text"
                      translationValue="telephoneSignInText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {currentTheme && (
                    <TranslationTextElement
                      label="Enter Slowly Text"
                      translationValue="telephoneEnterSlowlyText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Enter Number"
                      translationValue="telephoneEnterNumberText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Confirm"
                      translationValue="telephoneConfirmText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Is This Correct Text"
                      translationValue="telephoneIsThisCorrectText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Yes Text"
                      translationValue="yesText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="No Text"
                      translationValue="noText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Wizard"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"wizard"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("wizard")}>
                  {currentTheme && (
                    <TranslationTextElement
                      label="Welcome Text"
                      translationValue="wizardWelcomeText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Address Text"
                      translationValue="wizardAddressText"
                      replacementString={"%{name}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* {currentTheme && (
                    <TranslationTextElement
                      label="Entered Bags Text"
                      translationValue="wizardBagsText"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Entered Labels Text"
                      translationValue="wizardLabelsText"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )} */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Bags Prefix Text"
                      translationValue="wizardReturningText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {currentTheme && (
                    <TranslationTextElement
                      label="Bags Text"
                      translationValue="wizardBagsText"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {currentTheme && (
                    <TranslationTextElement
                      grouping="Singular"
                      label="Bag Text"
                      translationValue="wizardBagsText_1"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {currentTheme && (
                    <TranslationTextElement
                      label="Labels Prefix Text"
                      translationValue="wizardPrintingText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {currentTheme && (
                    <TranslationTextElement
                      label="Labels Text"
                      translationValue="wizardLabelsText"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {currentTheme && (
                    <TranslationTextElement
                      grouping="Singular"
                      label="Label Text"
                      translationValue="wizardLabelsText_1"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Thanks Text"
                      translationValue="wizardThanksText"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {/* -----------Section--------------- */}
                  {/* <Grid
                    item
                    xs={6}
                    style={{
                      display: currentLanguageTab == "Fr" ? "block" : "none",
                      alignContent: "center"
                    }}
                  >
                    Welcome Text
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      display: currentLanguageTab == "Fr" ? "block" : "none",
                      alignContent: "center"
                    }}
                  >
                    <TranslationTextField
                      translationValue="wizardWelcomeText"
                      language="Fr"
                      value={currentTheme.translations?.wizardWelcomeText?.Fr}
                      replacementString={"%{name}"}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  </Grid> */}
                  {/* -----------Section--------------- */}
                  {/* <Grid
                    item
                    xs={6}
                    style={{
                      display: currentLanguageTab == "En" ? "block" : "none",
                      alignContent: "center"
                    }}
                  >
                    Welcome Text
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    style={{
                      display: currentLanguageTab == "En" ? "block" : "none",
                      alignContent: "center"
                    }}
                  >
                    <TranslationTextField
                      translationValue="wizardWelcomeText"
                      language="En"
                      value={currentTheme.translations?.wizardWelcomeText?.En}
                      replacementString={"%{name}"}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  </Grid> */}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Footer"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"footer"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("footer")}>
                  {currentTheme && (
                    <TranslationTextElement
                      label="Back"
                      translationValue="footerBackText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="End"
                      translationValue="footerEndText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Select Bags"}
                  grouping={"Bags Only, Bags Only with Auth"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"bagsonly"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("bagsonly")}>
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Title"
                      translationValue="NumberOfBagsBagsOnlyTitleText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Bags Info1"
                      translationValue="NumberOfBagsBagsOnlyInfo1Text"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Bags Info1"
                      grouping="Singular"
                      translationValue="NumberOfBagsBagsOnlyInfo1Text_1"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Bags Description1"
                      translationValue="NumberOfBagsBagsOnlyDescription1Text"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Select Bags"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"select-bags"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("select-bags")}>
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Title"
                      translationValue="NumberOfBagsMainText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Bags Info 1"
                      translationValue="numberOfBagsInfo1"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Bags Description 1"
                      translationValue="numberOfBagsDescription1"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Bags Info 2"
                      translationValue="numberOfBagsInfo2"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      grouping="Singular"
                      label="Number of Bags Info 2"
                      translationValue="numberOfBagsInfo2_1"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Bags Description 2"
                      translationValue="numberOfBagsDescription2"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Select Labels"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"select-labels"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("select-labels")}>
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Title"
                      translationValue="NumberOfLabelsMainText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Labels Info 1"
                      translationValue="numberOfLabelsInfo1"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Labels Description 1"
                      translationValue="numberOfLabelsDescription1"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Labels Info 2"
                      translationValue="numberOfLabelsInfo2"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Number of Labels Description 2"
                      translationValue="numberOfLabelsDescription2"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Submission Approval"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"approval-screen"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("approval-screen")}>
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Title"
                      translationValue="SubmissionApprovalTitleText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Instruction Text"
                      translationValue="SubmissionApprovalInstructionText"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* {currentTheme && (
                    <TranslationTextElement
                      label="Instruction Text"
                      translationValue="approvalInstructionText"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )} */}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Ready to Print"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"ready-to-print"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("ready-to-print")}>
                  {currentTheme && (
                    <TranslationTextElement
                      label="Title Text"
                      translationValue="printTitleText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                </MyAccordionBody>
              </Grid>

              <Grid item xs={12}>
                <MyAccordionHeader
                  title={"Thank You"}
                  bgcolor={currentTheme.primaryColor}
                  expandedSectionFlag={"thank-you"}
                  expandedSections={expandedSections}
                  handleAccordionChange={handleAccordionChange}
                />
                <MyAccordionBody show={expandedSections.has("thank-you")}>
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Thank You"
                      translationValue="thankyouThankYouText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Step1 Header"
                      translationValue="thankyouStep1Header"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Step 1 Body"
                      translationValue="thankyouStep1Body"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Step 2 Header"
                      translationValue="thankyouStep2Header"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Step2 Body"
                      translationValue="thankyouStep2Body"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Step3 Header"
                      translationValue="thankyouStep3Header"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}

                  {/* -----------Section--------------- */}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Step3 Body"
                      translationValue="thankyouStep3Body"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      grouping="Singular"
                      label="Step3 Body"
                      translationValue="thankyouStep3Body_1"
                      replacementString={"%{count}"}
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                  {currentTheme && (
                    <TranslationTextElement
                      label="Finish Button Text"
                      translationValue="thankyouFinishButtonText"
                      currentLanguageTab={currentLanguageTab}
                      currentTheme={currentTheme}
                      onTranslationUpdate={handleTranslationUpdate}
                    />
                  )}
                </MyAccordionBody>
              </Grid>
              {/* ------------------------------------------------ */}
            </Grid>
          </center>
        </Table>
      </TableContainer>
    </>
  );
}
